"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var Styled = __importStar(require("./SessionTimeRange.styled"));
var clock_16_svg_1 = __importDefault(require("@/assets/svg/clock-16.svg"));
var utils_1 = require("@/utils");
var SessionTimeRange = function (_a) {
    var startedAt = _a.startedAt, endedAt = _a.endedAt;
    return ((0, jsx_runtime_1.jsxs)(Styled.SessionTimeRange, { children: [(0, jsx_runtime_1.jsx)(clock_16_svg_1.default, {}, void 0), (0, utils_1.formatDate)(startedAt, 'A hh:mm'), " - ", (0, utils_1.formatDate)(endedAt, 'A hh:mm')] }, void 0));
};
exports.default = SessionTimeRange;
